import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';

const AddReviewButton = props => {
  return (
    <NavLink
      to={props.link}
      onClick={props.onClick}
      className="add-review-button"
    >
      <span className="add-review-button__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="22"
          height="21"
        >
          <image
            data-name="add-review-button-icon"
            width="22"
            height="21"
            xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABnlBMVEX/RAD/////RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAD/RAAAAACtRW8vAAAAiHRSTlMAAA+ci0Ui62TTBK51u2lA3AYt5xAC0FCXjgk4jb4V6mErA0JypNXww5IlSZ7RyJZlNAel/YxXM6+y2G+9mAEkTVnSfwrFSt2ooIPNgIbZGs8vaM43ecfiI7C/YPZiSMIgZx5murw7rf5V3/FB+F+dU8bXdBl+TJrUVBLk6RPEhT4ybOV89OMus4gkwwAAAAFiS0dEiRxhJswAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfjAgcRJgBlKeI2AAABWElEQVQoz2NggAMmZhDJCAMICQaWDlbsMmzsHJxcWGW4eRh4+bDJ8AsIMggJi2DKiIqJA0kJSXQZKWkZWRAtJ6+gqASTYVJWUVVT19DUAivR1tFV19M3MDQCyhibmJppiSIcwmhkbmDRoQCU4bI0VkLyFMgeOStrsD2CNrZ2SDL2Do5OzlAXuLiawsXdON09PDXkvaQgbmPy9oFK+Popg5T7qwbIQVwtJxwIpoOCmRgYQ0KBcs5hUMvD/cF62SOALhCPBMrYRUWDJbhiwM6ONWaAyTDGxYNlEgTAlH4iQ1JCQnJKQkKCi0sMJDRTgURaekYmg4aYWFa2mJhYDmMuWCYvX7SgsIhDsxhhWokwWKY0TCCqzI5BOwwhw6cKlin3MATHREUlTKaqGizC4AL1qGFNDgNjEtCztXX1yCkECBqqbRvtGEuamr3s0GQYRFrEWlvbdNqBBgIA88M1367AeD4AAAAASUVORK5CYII="
          />
        </svg>
      </span>
      <span className="add-review-button__text">{props.text}</span>
    </NavLink>
  );
};

AddReviewButton.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default AddReviewButton;
